import { convertToLocalTime } from '@/composable/useFormatDateAndHours'
import { useReportStore } from '@/store/report'
import { storeToRefs } from 'pinia'
import { computed, ref, watch } from 'vue'
import { calculateTimeRange, createDemandChartOptions } from './demand-chart-config'

export function useCompareDemandChart() {
  const reportStore = useReportStore()
  const { comparePeriod } = storeToRefs(reportStore)

  const sensorData = ref(reportStore.getCompareEnergySensorReadings)

  const series = computed(
    () =>
      sensorData.value?.map((sensor) => ({
        name: sensor.sensorName,
        data:
          sensor.readings?.map((reading) => ({
            x: convertToLocalTime(reading.time),
            y: reading.total_power,
          })) || [],
      })) || [],
  )

  const timeRange = computed(() => {
    const [startDate, endDate] = comparePeriod.value || []
    return calculateTimeRange(startDate, endDate)
  })

  const chartOptions = computed(() =>
    createDemandChartOptions({
      chartId: 'report-demand-compare-chart',
      timeRange: timeRange.value,
    }),
  )

  watch(
    () => reportStore.getCompareEnergySensorReadings,
    (newData) => {
      sensorData.value = newData
    },
    { immediate: true, deep: true },
  )

  return {
    chartOptions,
    series,
    sensorData: computed(() => sensorData.value),
  }
}
